import { useEffect } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from '../../utils/MediaQuery';

const BreakpointChange = (props) => {
  const onBreakpointChange = () => {
    props.onChange(MediaQuery.current);
  };

  useEffect(() => {
    let windowMediaList = {};

    const queries = MediaQuery.queries;

    for (let key of Object.keys(queries)) {
      const mediaQueryList = window.matchMedia(queries[key]);

      try {
        mediaQueryList.addEventListener('change', onBreakpointChange);
      } catch {
        mediaQueryList.addListener(onBreakpointChange);
      }

      // Add to media so we can remove them
      windowMediaList[key] = mediaQueryList;
    }
    return () => {
      for (let key of Object.keys(windowMediaList)) {
        try {
          windowMediaList[key].removeEventListener(
            'change',
            onBreakpointChange
          );
        } catch {
          windowMediaList[key].removeListener(onBreakpointChange);
        }
      }
    };
  }, []);

  return null;
};

BreakpointChange.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default BreakpointChange;
